import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable, of, tap } from 'rxjs';
import { LoadingService } from '@common/loading/loading.service';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(
    private api: ApiService,
    private loading: LoadingService
  ) {}

  // GET API

  getDashboardListingProjectData() {
    return this.api.get(`/dashboard/listings-projects-data/${this.api.getUserId()}/${this.api.getOfficeId()}`);
  }

  /** Recent reports for the dashboard Reports widget — those shared with the user and ones they created. */
  getDashboardReports(limit = 5, userId: string = this.api.getUserId()) {
    return this.api.get(`/dashboard/data/reports/${userId}/${this.api.getOfficeId()}?limit=${limit}`);
  }

  /** Upcoming contract key dates for the Contract Key Dates widget. Backend clamps limit 1–100 (default 25). */
  getDashboardContractKeyDates(limit = 25) {
    return this.api.get(`/dashboard/data/contract-key-dates/${this.api.getUserId()}/${this.api.getOfficeId()}?limit=${limit}`);
  }

  // POST API
  saveDashboardWidget(payload: any) {
    // Invalidate the cached widget settings so the next getDashboardWidget()
    // re-fetches the freshly saved layout instead of serving the pre-save copy.
    // Without this, navigating away and back returns the stale cache (changes
    // appear lost until a hard refresh re-instantiates the service).
    return this.api.post('/dashboard/user-settings', payload).pipe(tap(() => (this.widgetCache = null)));
  }

  // PUT API

  pinUnpinToDashboard(url: string, id: string, payload?: any) {
    payload['user_id'] = this.api.getUserId();
    payload['office_id'] = this.api.getOfficeId();
    return this.api.put(`/${url}-pin-to-dashboard/` + id, payload);
  }

  // getDashboardWidget() {
  //   return this.api.get(`/dashboard/user-settings/${this.api.getUserId()}/${this.api.getOfficeId()}`);
  // }
  private widgetsCache: any = null;

  /** Call on logout so the next session does not reuse another user or office's cached dashboard. */
  clearDashboardCaches(): void {
    this.widgetsCache = null;
    this.widgetCache = null;
  }

  getDashboardData(): Observable<any> {
    const url = `/dashboard/data/${this.api.getUserId()}/${this.api.getOfficeId()}`;

    // If cached, immediately return it but also fetch fresh data in the background
    if (this.widgetsCache) {
      // Fire background request to update cache
      this.api.get(url).subscribe({
        next: freshData => {
          this.widgetsCache = freshData;
        },
        error: () => {
          this.loading.hide();
        },
      });
      // Return cached data immediately
      return of(this.widgetsCache);
    }

    // If no cache, fetch from API and cache it
    return this.api.get(url).pipe(tap(data => (this.widgetsCache = data)));
  }

  // getDashboardData() {
  //     return this.api.get(`/dashboard/data/${this.api.getUserId()}/${this.api.getOfficeId()}`);
  //   }
  private widgetCache: any = null;

  getDashboardWidget(): Observable<any> {
    const url = `/dashboard/user-settings/${this.api.getUserId()}/${this.api.getOfficeId()}`;

    // If cached, immediately return it but also fetch fresh data in the background
    if (this.widgetCache) {
      // Fire background request to update cache
      this.api.get(url).subscribe({
        next: freshData => {
          this.widgetCache = freshData;
        },
        error: () => {},
      });
      // Return cached data immediately
      return of(this.widgetCache);
    }

    // If no cache, fetch from API and cache it
    return this.api.get(url).pipe(tap(data => (this.widgetCache = data)));
  }
}
